module.exports = __webpack_public_path__ + "static/img/02023D_3_R_20200415_fit.e0a9a87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/02023D_3_R_20200415_fit.png
// module id = lIJS
// module chunks = 0